<template>
  <div class="contents koyoupdfdisp">

    <div class="container">
      <template v-if="isLoading">
        <template v-if="!isError">
          <div class="loading-container">
            <i class="fa-solid fa-spinner fa-spin-pulse"></i><br />
            <p>データ読み込み中...</p>
          </div>
        </template>
      </template>

      <template v-else>
        <div class="maininfo">
            <vue-pdf-embed
              :source="src"
            />
        </div><!-- /maininfo -->
      </template>
    </div><!-- container -->

    <div class="button-container">
      <p class="prev-page">
        <router-link :to="{
          name: RouterConst.KOYOUKEIYAKU_DETAIL,
          params: {
            id: id,
          }
        }">詳細画面に戻る
        </router-link>
      </p>

      <!-- TODO:履歴書をダウンロードして良いか確認する-->
      <p class="btn-temporary-save">
        <button type="button" @click="useDownLoad()">
          <i class="fa-solid fa-file-lines"></i>ダウンロード
        </button>
      </p>
    </div><!-- button-container -->

  </div><!-- contents -->
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import VuePdfEmbed from 'vue-pdf-embed'
import { useInit } from '@/composable/koyoukeiyaku/pdfdispinit';
import { usePrint } from '@/composable/koyoukeiyaku/pdfdownload';
import { RouterConst } from '@/const/Router';
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {

    // 初期化
    const { getPDFURL, downloadPDF, isLoading, isError } = useInit();

    const { } = usePrint();

    // 雇用契約IDを取得
    const route = useRoute();
    const id = parseInt(route.params.id as string, 10);

    const src = {
      url: getPDFURL(),
      // cMapUrl: '../../../../../node_modules/cmaps/',
      // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.11.338/cmaps/', // TODO: node_modules内のcmapから取りたい
      // cMapPacked: true
    };

    // ダウンロードするボタンクリック
    const useDownLoad = () => {
        let link = document.createElement('a');
        link.href = downloadPDF();
        link.click();
        link.remove();
    }

    return {
      src,
      isLoading,
      isError,
      useDownLoad,
      RouterConst,
      id,
    }
  },
  components: {
    VuePdfEmbed
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-pdf.scss';
</style>
